var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import S3ImageUploader from "@components/common/s3-image-uploader";
import { PeekButton, PeekDialog, PeekDialogActions, PeekDialogContent, } from "@piiqtechnologies/ui-components";
import { SIGNED_URL_UPLOAD_TYPE, uploadFileToPreSignedURL, useAnalytics, useError, useLoader, useNotification, useRefetch, useSignedURL, useUpdateSpace, } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const SpaceUploadFloorplanDialog = ({ floorplan, spaceId, open, onClose }) => {
    const intl = useIntl();
    const [floorplanImage, setFloorplanImage] = useState(null);
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setNotification } = useNotification();
    const { setRefetch } = useRefetch();
    const analytics = useAnalytics();
    const [updateSpace, spaceUpdated, isUpdatingSpace, updateSpaceError] = useUpdateSpace();
    const [getImageUploadURL] = useSignedURL();
    useEffect(() => {
        setLoader(isUpdatingSpace);
        return () => setLoader(false);
    }, [isUpdatingSpace]);
    useEffect(() => {
        if (updateSpaceError) {
            setError(updateSpaceError === null || updateSpaceError === void 0 ? void 0 : updateSpaceError.message);
        }
    }, [updateSpaceError]);
    useEffect(() => {
        if (spaceUpdated) {
            setRefetch();
            analytics.track("Floorplan Uploaded");
            setNotification(intl.formatMessage(messages.updateSpaceFloorplanSuccess));
            onClose();
        }
    }, [spaceUpdated]);
    const onFloorplanChange = () => __awaiter(void 0, void 0, void 0, function* () {
        let floorplanUrl = null;
        try {
            setLoader(true);
            if (floorplanImage) {
                floorplanUrl = `${spaceId}/${floorplanImage.file.name}`;
                const uploadURL = yield getImageUploadURL({
                    uploadType: SIGNED_URL_UPLOAD_TYPE.FLOORPLAN,
                    fileName: floorplanUrl,
                });
                yield uploadFileToPreSignedURL(uploadURL, floorplanImage.file);
            }
            else {
                floorplanUrl = "";
            }
        }
        catch (ex) {
            setError((ex === null || ex === void 0 ? void 0 : ex.message) || "Error uploading image to s3");
            console.log("Error uploading image to s3", ex);
        }
        finally {
            setLoader(false);
        }
        const spaceAtts = {
            _id: spaceId,
            floorPlan: {
                name: floorplan.name,
                url: floorplanUrl,
            },
        };
        updateSpace(spaceAtts);
    });
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "xs", fullWidth: true, hasCloseIcon: true, title: intl.formatMessage(messages.updateSpaceFloorplanTitle), open: open, onClose: onClose },
        React.createElement(PeekDialogContent, null,
            React.createElement(S3ImageUploader, { imageKey: spaceId, imageUrl: floorplan === null || floorplan === void 0 ? void 0 : floorplan.url, onChangeLazyS3Upload: setFloorplanImage, bucket: SIGNED_URL_UPLOAD_TYPE.FLOORPLAN, lazyS3Upload: true })),
        React.createElement(PeekDialogActions, null,
            React.createElement(PeekButton, { fullWidth: true, size: "large", disabled: floorplan === null, onClick: onFloorplanChange, color: "primary", variant: "contained" }, intl.formatMessage(messages.updateSpaceFloorplanButton)))));
};
export default SpaceUploadFloorplanDialog;
